import { FunctionComponent } from 'react';

const RdConfig: FunctionComponent = () => {
  return null;
};

export default RdConfig;
